import { CalculationSettingsModel, RNAVModel } from './configuration';
import { NavaidDTOCalculation } from './navaid';

export class docAndSectorizationDTO {
  name:string;
  navaids: NavaidDTOCalculation[] = [];
  calculationSettings: CalculationSettingsModel = new CalculationSettingsModel();
  rnav: RNAVModel;
  projectId: number;
}
